(function() {
  'use strict';

  function EasApiService(
    $http, $q, $log, $timeout, Network, OidcService, ClusterService, DB_ERRORS
  ) {
    var service = {};

    var VERSION = 'v2';

    function getDownloadFilename(contentDisposition) {
      var filenameMatch = /filename\s*=\s*(?:"((?:\\.|[^"])*)"|([^;]*))/i
        .exec(contentDisposition || '');

      if (!filenameMatch) {
        return 'noname';
      }

      if (filenameMatch[1] !== undefined) {
        return filenameMatch[1].replace(/\\(.)/g, '$1');
      }

      return filenameMatch[2].trim();
    }

    service.getAPI_URL = function() {
      var urls = ClusterService.getCurrentUrls();
      return _.trimEnd(urls.api, '/');
    };

    service.absUrl = function(path, options) {
      var opts = options || {};
      var url = service.getAPI_URL();
      url += url.endsWith('/') ? '' : '/';
      url += opts.version !== undefined ? opts.version : VERSION;
      url += url.endsWith('/') ? '' : '/';
      url += path;
      return url;
    };

    service.call = function(method, path, data, urlParams, options) {
      options = options || {};

      if (!options.force && Network.isOffline()) {
        return $q.reject(DB_ERRORS.notAvailableOffline);
      }

      var url = service.absUrl(path, options);
      var ldata = urlParams;

      $log.debug(url);
      function handleError(error) {
        if (error && error.status === 0) {
          $log.warn('Rest API: No response from server');
          return $q.reject(
            { status: 0, message: 'Cannot reach the server. Your connection is down.' }
          );
        }

        var status = error.status || 0;
        var errText;
        var errDetail;

        if (_.isEmpty(error.data)) {
          errText = 'Cannot reach the server';
        } else if (_.isString(error.data)) {
          errText = error.data;
          errDetail = error.data.details;
        } else {
          errText = error.data.message;
          errDetail = error.data.details;
        }

        return $q.reject({ status: status, message: errText, details: errDetail });
      }

      // OidcService is a downgraded Angular service and returns a native
      // Promise. Normalise to $q so the whole AngularJS layer stays digest
      // aware and unhandled rejections reach $exceptionHandler rather than
      // window.onunhandledrejection.
      var apiHeaders = function() {
        return $q.when(OidcService.getApiHeaders());
      };

      if (method === 'BLOB') {
        method = 'GET';
        return apiHeaders().then(function(apiInfo) {
          return $http({
            method: method,
            url: url,
            params: (method === 'GET') ? ldata : {},
            data: (method !== 'GET') ? data : {},
            withCredentials: true,
            headers: {
              Authorization: apiInfo.token,
              'EAS-Organisation': apiInfo.organisation,
              'EAS-Username': apiInfo.username,
              'Accept-Language': ClusterService.locale || 'en'
            },
            responseType: 'blob' // very important, otherwise zip file won't work
          });
        })
          .then(function(result) {
            var headers = result.headers();
            var blobName = 'noname';
            if (headers['content-disposition']) {
              blobName = getDownloadFilename(headers['content-disposition']);
            }

            var blobContent = result.data,
                blobType = result.headers('content-type').split(';')[0];

            var blob = new Blob([blobContent], { type: blobType });
            var a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.download = blobName;
            a.style.display = 'none';
            // a.srcObject = blob;

            document.body.appendChild(a);
            a.click();

            $timeout(function() { window.URL.revokeObjectURL(url); }, 10 * 60 * 1000);
          });
      } else if (method === 'MULTIPART') {
        const fd = new FormData();
        fd.append('data', JSON.stringify(data));

        _.forEach(options.files || {}, function(fi, name) {
          const blob = new Blob([fi], { type: fi.type });
          fd.append(name, blob);
        });

        return apiHeaders().then(function(apiInfo) {
          return $http.post(url, fd, {
            // transformRequest: angular.identity,
            headers: {
              'Content-Type': undefined,
              Authorization: apiInfo.token,
              'EAS-Organisation': apiInfo.organisation,
              'EAS-Username': apiInfo.username,
              'Accept-Language': ClusterService.locale || 'en'
            }
          });
        })
          .then(function(resp) { return resp.data; })
          .catch(handleError);
      }

      return apiHeaders().then(function(apiInfo) {
        return $http({
          method: method,
          url: url,
          params: (method === 'GET') ? ldata : {},
          data: (method !== 'GET') ? data : {},
          withCredentials: true,
          headers: {
            Authorization: apiInfo.token,
            'EAS-Organisation': apiInfo.organisation,
            'EAS-Username': apiInfo.username,
            'Accept-Language': ClusterService.locale || 'en'
          }
        });
      }).then(function(resp) {
        return resp.data;
      }).catch(function(error) {
        if (error && error.status === 0) {
          $log.warn('Rest API: No response from server');
          return $q.reject(
            { status: 0, message: 'Cannot reach the server. Your connection is down.' }
          );
        }

        var status = error.status || 0;
        var errText;
        var errDetail;

        if (_.isEmpty(error.data)) {
          errText = 'Cannot reach the server';
        } else if (_.isString(error.data)) {
          errText = error.data;
          errDetail = error.data.details;
        } else {
          errText = error.data.message;
          errDetail = error.data.details;
        }

        return $q.reject({ status: status, message: errText, details: errDetail });
      });
    };

    service.get = function(path, data, urlParams, options) {
      return service.call('GET', path, data, urlParams, options);
    };

    service.post = function(path, data, urlParams, options) {
      return service.call('POST', path, data, urlParams, options);
    };

    service.downloadBlob = function(path, data, urlParams, options) {
      return service.call('BLOB', path, data, urlParams, options);
    };

    service.postMultiPart = function(path, data, urlParams, files, options) {
      options = options || {};
      options.files = files;
      return service.call('MULTIPART', path, data, urlParams, options);
    };

    service.put = function(path, data, urlParams, options) {
      return service.call('PUT', path, data, urlParams, options);
    };

    service.delete = function(path, data, urlParams, options) {
      return service.call('DELETE', path, data, urlParams, options);
    };

    return service;
  }

  EasApiService.$inject = [
    '$http',
    '$q',
    '$log',
    '$timeout',
    'NetworkService',
    'OidcService',
    'ClusterService',
    'DB_ERRORS'
  ];

  angular.module('blocks.easapi')
    .service('EasApiService', EasApiService);
})();
